import { render } from "./SystemAdmin1.vue?vue&type=template&id=80964ee6"
import script from "./SystemAdmin1.vue?vue&type=script&lang=js"
export * from "./SystemAdmin1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__